import {
    DELETE_WEBHOOK,
    DELETE_WEBHOOK_FAILURE,
    DELETE_WEBHOOK_SUCCESS,
} from 'store/actions/types';

export const deleteWebhook = (payload) => {
    return {
        type: DELETE_WEBHOOK,
        payload: payload,
    };
};

export const deleteWebhookFailure = (error) => {
    return {
        type: DELETE_WEBHOOK_FAILURE,
        error: error,
    };
};

export const deleteWebhookSuccess = (payload) => {
    return {
        type: DELETE_WEBHOOK_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/webhooks/deleteWebhooks.js